import { XInputValues } from './lib/gamepad';

export type * from './lib/api';
export type * from './lib/types';
export type * from './lib/gamepad';
export type * from './lib/hub';
export type * from './lib/keyboard';
export type * from './lib/mouse';
export type * from './lib/peer';
export type * from './lib/player';
export type * from './lib/stream';
export type * from './lib/system';
export type * from './lib/core';
export type * from './lib/user';
export type * from './lib/roster';
export type * from './lib/store';
export type * from './lib/electron';
export type * from './lib/logger';
export type * from './lib/remote';
export type * from './lib/process';
export type * from './lib/encoder';
export type * from './lib/input';
export type * from './lib/orchestrator';
export { XInputValues };

export enum IdentityPlatform {
  DISCORD = 'discord',
  TWITCH = 'twitch',
  CLERK = 'clerk',
}

export type Vector2 = {
  x: number;
  y: number;
};

export type PlaycastWindowState = 'minimized' | 'maximized' | 'closed' | 'normal';

export type PlaycastHostEdition = 'standard' | 'pavilion';

export type Serializable = string | number | boolean | null | undefined | Serializable[] | { [key: string]: Serializable };

